import { Component, OnInit } from '@angular/core';
import { I18nService } from 'core-app/modules/common/i18n/i18n.service';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';



@Component({
  templateUrl: './EarlyWarnings.component.html',
  styleUrls: ['./EarlyWarnings.component.sass']
})
export class EarlyWarningsComponent implements OnInit {
  public projectId: string;
  public Contract_Management_data:any[] = []
  public loading: boolean = true;

  constructor(
    readonly http: HttpClient,
    public i18n: I18nService
  ) {}

  ngOnInit() {
    const currentProject: any = document.querySelector('meta[name=current_project]');
    this.projectId = currentProject.dataset.projectId;
    this.getData();
  }

  public specialClass=['Durations of all Closed Early Warnings','Classification of Grounds for Compensation Events','Classification of Root Causes of Compensation Events',
    'date_notification','date_implementation','duration','date_quotation_req','date_quotation_sub','date_quotation_submission','date_pm_response',
    'cost_implication','time_implication',
  ]
  public special3=['Ratio of Price for Work Done to Date (PWDD) to forecast final PWDD']
  handleClass(item:any){
    if(this.specialClass.includes(item.title)){
      return 'entry-risc special47'
    }
    if(this.special3.includes(item.title)){
      return 'entry-risc special3'
    }
    return 'entry-risc'
  }
  getData() {
     // 获取合同管理数据
     const cmKeys = ['cm9','cm10','cm11']
     let params = new HttpParams()
     cmKeys.forEach(key => { params = params.append('cm_keys[]', key) })
    this.http.get(`/api/v3/projects/${this.projectId}/overviews/contract_management`,{params}).subscribe(res => {
      console.log(res)
      this.loading = false
      this.Contract_Management_data =[]
      const data = Object.values(res)
      const priceType=['Price for Work Don to Date (PWDD)','Forecast final PWDD','Forecast final total of th Prices','Changed Total of the Price to date',
        'Forecast Total of the Prices','Sum of Cost Implication (in $)','Average Cost Implication']
      const percentType=['Ratio of Price for Work Done to Date (PWDD) to forecast final PWDD','Ratio of forecast final PWDD to forecast final total of th Prices',
        'Ratio of Changed Total of the Price to date to forecast Total of the Prices','Ratio of Time Elapsed to Contractual Duration','Ratio of Time Elapsed to Planned Duration',
        'Ratio of Resolved Early Warnings to Total number of Early Warnings','Ratio of Implemented Compensatio n Events to Notified Compensatio n Events'
      ]
      const dayType= ['Time Elapsed','Contractual Duration','Time Elapsed cm05','Planned Duration for completion','Average Duration to Resolve Early Warnings duration',
        'Average duration from Notification to Implementatio n of Compensation Events','Average duration of Quotation Submission from Contractor','Average duration of quotation assessment'
      ]
      const titleDay =['Durations of all Closed Early Warnings']
      const remask =['Scenario']
      data.forEach(item=>{
        if(Array.isArray(item)){
          item.forEach((items:any,index)=>{
            let show = true
            if(index<=0){
              show = true
            }else{
              show =Object.values(items)[0]?true:false
            }
            let title =Object.keys(items)[0]== 'Contract Key Date ' + (index+1) ?'Contract Key Date':'Contract Sectional Completion Date'
            const data = {type:'more',title:title,show:show, ...items}
            console.log(data);
            if(priceType.includes(data.title)&&data.value!=='--'){
              data.value = 'HK' + data.value.toLocaleString('en-US')
            }
            if(percentType.includes(data.title)&&data.value!=='--'){
              data.value = data.value + '%'
            }
            if(dayType.includes(data.title)&&data.value!=='--'){
              data.showDay = true
            }
            if(remask.includes(data.title)){
              data.remask = 'Let R = (Forecast final PWDD/Forecast final total of the Price)*100% Scenario A: [R < 100%] Scenario B: [100% <= R <=110%] Scenario C: [R > 110%]'
            }
            if(titleDay.includes(data.title)){
              data.titleShowDay = true
            }
            this.Contract_Management_data.push(data)
          })
        }else{
            for (let key in item) {
              if (item.hasOwnProperty(key)) { // 确保是自身属性，而不是继承的
                 console.log(key,item[key],'item,222');
                 const data = {
                    show:true,
                    title:key,
                    value:item[key]?item[key]:'--',
                    remask:'',
                    showDay:false,
                    titleShowDay:false
                 }
                   if(priceType.includes(data.title)&&data.value!=='--'){
                      data.value = 'HK' + data.value.toLocaleString('en-US')
                    }
                    if(percentType.includes(data.title)&&data.value!=='--'){
                      data.value = data.value + '%'
                    }
                    if(dayType.includes(data.title)&&data.value!=='--'){
                      data.showDay = true
                    }
                  if(remask.includes(data.title)){
                      data.remask = 'Let R = (Forecast final PWDD/Forecast final total of the Price)*100% Scenario A: [R < 100%] Scenario B: [100% <= R <=110%] Scenario C: [R > 110%]'
                    }
                     if(titleDay.includes(data.title)){
                      data.titleShowDay = true
                    }
                    this.Contract_Management_data.push(data)
              }
            }
        }
      })
    })
  }

}

